import React, { useState } from 'react';
import Hero from './components/Hero';
import Navigation from './components/Navigation';
import CaseStudyCard from './components/CaseStudyCard';
import CaseStudyModal from './components/CaseStudyModal';
import DevProjectCard from './components/DevProjectCard';
import Footer from './components/Footer';
import { caseStudies } from './data/caseStudies';
import { devProjects } from './data/devProjects';

export default function App() {
  const [activeSection, setActiveSection] = useState('product');
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedCase, setSelectedCase] = useState(null);

  const openModal = (caseStudy) => {
    setSelectedCase(caseStudy);
    setModalOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedCase(null);
    document.body.style.overflow = 'unset';
  };

  return (
    <div className="min-h-screen bg-amber-50">
      <Hero />
      <Navigation activeSection={activeSection} setActiveSection={setActiveSection} />

      <main className="max-w-5xl mx-auto px-6 md:px-12 lg:px-24 py-16">
        {activeSection === 'product' && (
          <section>
            <h2 className="text-4xl font-black mb-12 pb-3 border-b-2 border-black inline-block">
              Case Studies
            </h2>
            <div className="space-y-8">
              {caseStudies.map((caseStudy) => (
                <CaseStudyCard 
                  key={caseStudy.id} 
                  caseStudy={caseStudy} 
                  onOpenModal={openModal} 
                />
              ))}
            </div>
          </section>
        )}

        {activeSection === 'dev' && (
          <section>
            <h2 className="text-4xl font-black mb-12 pb-3 border-b-2 border-black inline-block">
              Projects
            </h2>
            <div className="grid md:grid-cols-2 gap-6">
              {devProjects.map((project, idx) => (
                <DevProjectCard key={idx} project={project} />
              ))}
            </div>
          </section>
        )}
      </main>

      <Footer />

      {modalOpen && <CaseStudyModal caseStudy={selectedCase} onClose={closeModal} />}
    </div>
  );
}
